import { Inject, Injectable } from '@tanbo/vue-di-plugin'
import {
  BaselineItemTreeOperationService
} from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/baseline-item-tree-operation.service'
import {
  RepairTreeItem, SystemCategoryName,
  SystemType,
  SystemTypeInjectionToken
} from '@/views/dashboard/safe-status/base-line/repair-item-tree-type'
import {
  applyBaselineRepairDisplayNamesToTree,
  DUBA_BASELINE_REPAIR_ITEMS_KEY
} from '@/views/dashboard/safe-status/base-line/baseline-repair-items-cache'

@Injectable()
export class RepairItemTreeService extends BaselineItemTreeOperationService {
  baseLineItem: RepairTreeItem[]
  constructor (@Inject(SystemTypeInjectionToken) private systemType: SystemType) {
    super()
    const raw = localStorage.getItem(DUBA_BASELINE_REPAIR_ITEMS_KEY)
    const branch = raw ? JSON.parse(raw)?.[SystemCategoryName?.[this.systemType]] : []
    this.baseLineItem = applyBaselineRepairDisplayNamesToTree(branch)
  }

  generateRenderTree (ids: string[], fatherName = '') {
    return this.generateSecondTree(this.generateOriginalTreeWithIds(JSON.parse(JSON.stringify(this.baseLineItem)), ids, fatherName))
  }
}
